import React, { useState, useEffect } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { setCtiSetting } from 'flow/utils/cti-settings-utils';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import SettingRow from 'flow/components/Setting/SettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import useCustomer from 'flow/hooks/useCustomer';
import { CTISettings, CTISingleSettingKey } from 'flow/types/CTISettings';
import { ExtensionKey } from 'flow/types/EntityKeys';

type Props = {
    extensionKey: ExtensionKey;
    setting: CTISettings;
    propertyName: CTISingleSettingKey;
};

const CtiSetting = ({ extensionKey, setting, propertyName }: Props) => {
    const { i18next } = useAppContext();

    const { ownCustomerKey } = useCustomer(extensionKey);
    const [settingsValue, setSettingsValue] = useState(
        setting[propertyName].value,
    );
    const [isDisabled, setDisabled] = useState(false);

    useEffect(() => {
        //customer-258837 Eniro Sverige AB required, that we will force Call Logging to always be enabled, even if someone tries to disable it in settings
        if (
            ownCustomerKey === 'customer-258837' &&
            propertyName == 'logCallsAutomatically'
        ) {
            setSettingsValue(true); //set logCallsAutomatically to be true
            setDisabled(true); //disable the logCallsAutomatically toggle
        }
    }, [ownCustomerKey, propertyName]);

    const updateConfiguration = (value: boolean) => {
        setSettingsValue(value);
        setting[propertyName].value = value;
        addCtiLogEntry(`setting ${propertyName} was changed to ${value}.`);
        setCtiSetting(setting);
    };

    return (
        <SettingRow
            cta={
                <Toggle
                    value={!!settingsValue}
                    disabled={isDisabled}
                    onChange={updateConfiguration}
                    text={i18next.t(setting[propertyName].label)}
                />
            }
        >
            {i18next.t(setting[propertyName].label)}
        </SettingRow>
    );
};

export default CtiSetting;
